import React, { useState } from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import {
  EstatePlanStatusLayout,
} from 'Components/Flyouts/HouseholdInfo/Sections/Service/HouseholdSectionServicePicker/HouseholdSectionService/EstatePlanStatusOptions/EstatePlanStatusLayout';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { TextInputLarge } from 'Packages/FacetDesign/Components';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('excludeFromCampaignReasonDetails',
    {
      _component: () => TextInputLarge,
      _customProps: {
        rows: 3,
      },
    });

const EstatePlanStatusOptions = ({ estatePlanningStatusResource }) => {
  const [dirty, setDirty] = useState(false);
  return (
    <MetaResourceRenderer
      metaOverrideSet={metaOverrideSet}
      resource={estatePlanningStatusResource}
      layout={EstatePlanStatusLayout}
      LayoutProps={{
        dirty,
      }}
      onChange={() => setDirty(true)}
      onSubmit={() => setDirty(false)}
    />
  );
};

EstatePlanStatusOptions.defaultProps = {};

EstatePlanStatusOptions.propTypes = {
  estatePlanningStatusResource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { EstatePlanStatusOptions };
